var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.codmetodopago == null)?_c('span',[_vm._v(" Met. Pago Automático ")]):_vm._e(),(_vm.codmetodopago == 'PPD')?_c('span',[_vm._v(" PPD ")]):_vm._e(),(_vm.codmetodopago == 'PUE')?_c('span',[_vm._v(" PUE ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }